import React, {Component} from "react";
import {Col, Row} from "reactstrap";
import IconCard from "../components/cards/IconCard";
import {numberWithCommas} from "../helpers/Utils";
import {withTranslation} from "react-i18next";

class NotificationStats extends Component {
  render() {
    const {t, data} = this.props;
    return (
      <Row>
        <Col className='col-12 col-md-6 col-lg-4'>
          <IconCard
            icon="icon-Bar-Chart3"
            title={t('Total Count')}
            value={data ? numberWithCommas(data.total) : null}
          />
        </Col>
        <Col className='col-12 col-md-6 col-lg-4'>
          <IconCard
            icon="icon-Eye"
            title={t('Seen Count')}
            value={data ? numberWithCommas(data.seen) : null}
          />
        </Col>
        <Col className='col-12 col-md-6 col-lg-4'>
          <IconCard
            icon="icon-Business-Mens"
            title={t('Delivered Count')}
            value={data ? numberWithCommas(data.delivered) : null}
          />
        </Col>
      </Row>
    );
  }
}

export default withTranslation()(NotificationStats);